// @flow

import { ArrowLeft } from 'lucide-react';

import { selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button, Heading, Tag } from '@gandi/ui';

import { useIsMobile } from 'src/Layout/hooks';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectCountBulkResults, selectBulkResponse } from '../modules/cart';

import { DomainCount } from './DomainCount';

import { useActiveKind } from './context/ActiveKindContext';

import styles from './Header.scss';

export const Header = (): React.MixedElement => {
  const { __ } = useTranslator();

  const isMobile = useIsMobile('(max-width: 40em)');
  const cartId = useAppSelector(selectCartUUID);

  const count = useAppSelector(selectCountBulkResults);
  const results = useAppSelector(selectBulkResponse);

  const creatable = results.creatable.length;
  const transferable =
    results.transferable.length + results.transfer_error.length;
  const unavailable = results.unavailable.length;

  const activeKind = useActiveKind();

  const headerContent = (
    <>
      <div className={styles.info}>
        <Button
          kind="outline"
          small
          className={styles.addDomainBtn}
          to={`/domain/transfer/${cartId}?bulk`}
        >
          <ArrowLeft />
          {__('Add domains')}
        </Button>
        <div className={styles.title}>
          <Heading as="h1">{__('Multiple Domain Transfer Results')}</Heading>
          <DomainCount count={count} />
        </div>
      </div>
      <ul className={styles.nav}>
        <li>
          <Tag
            size="medium"
            addon={transferable}
            href={transferable > 0 ? '#transferable' : undefined}
            active={activeKind === 'transferable'}
          >
            {__('Ready to transfer')}
          </Tag>
        </li>
        <li>
          <Tag
            size="medium"
            addon={creatable}
            href={creatable > 0 ? '#creatable' : undefined}
            active={activeKind === 'creatable'}
          >
            {__('Registration')}
          </Tag>
        </li>
        <li>
          <Tag
            size="medium"
            addon={unavailable}
            href={unavailable > 0 ? '#unavailable' : undefined}
            active={activeKind === 'unavailable'}
          >
            {__('Unavailable')}
          </Tag>
        </li>
      </ul>
    </>
  );

  return !isMobile ? (
    <div className={styles.root}>{headerContent}</div>
  ) : (
    headerContent
  );
};
